import brand from '@helpers/brand';
import { fonts } from '@helpers/fonts';
import { Device, from } from '@helpers/media';
import { ThemeSwitch } from '@helpers/theme';
import { ReactComponent as SvgClose } from '@img/icons/close.svg';
import { ContactUsStyles } from '@stories/Widgets/Forms/ContactUs/ContactUs.styles';
import styled from 'styled-components';
const Container = styled.aside `
  display: none;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 8002; /* above the header search field (8001), below the YourSolution modal */
  width: 720px;
  max-width: calc(100vw - 48px);
  max-height: calc(100vh - 48px);
  overflow-y: auto; /* scroll within the modal on short screens, so the submit button is reachable */
  padding: 48px;
  background-color: ${brand.white};
  ${ThemeSwitch({ groundforceColour: brand.primary.alt })};
  border-top: 12px solid var(--theme);
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.2);

  @media ${from(Device.DesktopSmall)} {
    &[data-open='true'] {
      display: block;
    }
  }

  ${ContactUsStyles.FormGrid} {
    gap: 24px;
  }
`;
const Title = styled.p `
  ${fonts.DaxPro.Bold};
  font-size: 32px;
  line-height: 36px;
  margin: 0 40px 32px 0;

  &[data-hidden='true'] {
    position: absolute;
    width: 1px;
    height: 1px;
    margin: -1px;
    padding: 0;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
  }
`;
const CloseButton = styled.button `
  position: absolute;
  top: 24px;
  right: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  border: none;
  background: none;
  color: ${brand.black};
  cursor: pointer;

  &:focus-visible {
    outline: 2px solid var(--theme);
  }
`;
const CloseIcon = styled(SvgClose) `
  width: 16px;
  height: 16px;
`;
export const ContactUsFormModalStyles = {
    Container,
    Title,
    CloseButton,
    CloseIcon,
};
